import charts from './libs/charts';
import colors from './libs/colors';
import main from './libs/main';
import popovers from './libs/popovers';
import toasts from './libs/toasts';
import tooltips from './libs/tooltips';
import widgets from './libs/widgets';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    charts();
    colors();
    popovers();
    toasts();
    tooltips();
    widgets();
    main();
  },
};



// WEBPACK FOOTER //
// ./scripts/main.js